import axios from 'axios'

export default function request (config) {
  const instance = axios.create({
    baseURL: 'https://sytdp-console.chuangxing.ren',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })

  // 请求拦截
  instance.interceptors.request.use(
    config => {
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  // 响应拦截
  instance.interceptors.response.use(
    response => {
      return response.data.data
    },
    error => {
      console.log(error)
    }
  )
  return instance(config)
}
